import { mediaMixin, spaceMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';

import { Col } from '@zillow/zrs-comet';

const hpAccent = '#DBDBDB';

export const StyledCol = styled(Col).attrs({ useSpacingMixin: true })``;

export const StyledPhotoUpload = styled.div(({ theme }) => css`
    .property-image, &.property-image {
        margin-left: -${spaceMixin('xs')};
        padding-left: ${spaceMixin('sm')};
        margin-right: -${spaceMixin('xs')};
        padding-right: ${spaceMixin('sm')};
    }
    .sort-handle {
        display: none;
        ${mediaMixin('lg', css`
            color: ${hpAccent};
            cursor: move;
            display: table-cell;
            font-size: 100px;
            line-height: 10px;
            padding-right: ${spaceMixin('xl')};
            vertical-align: middle;
            user-select: none;
        `)}
    }
    .photo-table-display {
        width: 100%;
        ${mediaMixin('lg', css`
            display: table-cell;
        `)}
    }
    &.on-drag {
        background-color: ${theme.ns().colors.white};
        border: 1px solid ${hpAccent};
    }
`);

export const PhotoUploadDropzoneContainer = styled.div`
    display: flex;
    flex-flow: column;

    /* override mui */
    .DropzoneContainer {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        min-height: 200px;
    }

    /* override */
    .IconItem {
        align-items: center;
        flex: 1 0 0;
    }
`;
